module.exports = __webpack_public_path__ + "static/media/14.04f3f848.mp3";